export const figure25 = { 
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
      colors: ['#bfbfbf','#ff0000','#00b050'],

      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          stacking: 'normal',
          },
          column: {
              stacking: 'percent'
          }
      },
  
      exporting: {
        enabled: false
      },
  
  
      xAxis: [{
        categories: [ "Afrique", "Amériques", "Asie", "Europe", "Océanie", "Monde",],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px',
          }
        },
      }],
      yAxis: {
        min: 0,
        title: {
            text: ''
        }
    },
    tooltip: {
        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
        shared: true
    },
    legend: {
        enabled: false,
      },
 
      series: [
        {
            name: 'Races locales pour lequel le niveau de risque n’est pas connu',
            color: '#bfbfbf',
            data: [ 768, 516, 1845, 1072, 188, 4389,  ]
        },
        {
          name: 'Races locales menacées',
          color: '#ff0c00',
          data: [ 55, 105, 90, 1700, 23, 1973]
      },
        {
            name: 'Races locales non menacées',
            color: '#0eb050',
            data: [ 128, 58, 221, 347, 0, 754 ]
        },
       
      ]
}
